/*
* Api call to server that are related to profile.
*/
import env from '../config/env.js'
const apiUrl=env.apiUrl;

function checkStatus(response) {
  if( response.status === 401 ) {
    window.location = '/login'; // TODO: This should use the router?
  }

  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    var error = new Error(response.statusText);
    console.warn("Error in HTTP Request", response.status, response);
    error.response = response;
    if( response.json ) {
      throw response.json();
    }
    else {
      throw error;
    }
  }
}

function parseJSON(response) {
  return response.json();
}


export function editProfilePic(formdata,userId,compId){
  return fetch(apiUrl+`/api/profile/edit/${userId}/uploadPic/${compId}`, {
    headers: {
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: formdata
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export function editProfileSave(image,name,type,email,currentEmail){
  const formdata={ image,name,type,email,currentEmail };
  return fetch(apiUrl+`/api/profile/edit`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(formdata)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export function updatePassword(email,oldpass,newpass){
  const formdata={ email,oldpass, newpass };
  return fetch(apiUrl+`/api/profile/edit/password`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(formdata)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};
export function editMemberSave(name,type,email,id){
  const formdata={ name,type,email,id };
  return fetch(apiUrl+`/api/profile/edit/team`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(formdata)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export function addMemberSave(name,type,email,id,companyId){
  const formdata={ name,type,email,id,companyId };
  return fetch(apiUrl+`/api/profile/add/team`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(formdata)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};

export function checkOldPassword(email,oldpass){
  const formdata={ email,oldpass };
  return fetch(apiUrl+`/api/profile/check/password`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + window.localStorage.getItem('agl-token'),
    },
    method: 'POST',
    body: JSON.stringify(formdata)
  }).then(checkStatus).then(parseJSON).then((json) => {
    return json;
  });
};


// WEBPACK FOOTER //
// ./src/api/profileEdit.js